export default __webpack_public_path__ + "static/media/html5-silver.93228692.png";